//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Array,
            required: true,
        },
        initialMin: {
            type: Number,
            default: 0,
        },
        initialMax: {
            type: Number,
            default: 100,
        },
        step: {
            type: Number,
            default: 1,
        },
        sliderType: {
            type: String,
            default: 'price',
        },
    },
    data() {
        return {
            minValue: this.initialMin,
            maxValue: this.initialMax,
            numberInputStyle: 'w-1/2 border border-gray-300 rounded-md p-2',
            rangeInputStyle: 'absolute appearance-none pointer-events-none h-full',
        };
    },
    watch: {
        value: {
            handler() {
                this.minValue = this.getValue('min');
                this.maxValue = this.getValue('max');
            },
            deep: true,
        },
    },
    mounted() {
        this.minValue = this.getValue('min');
        this.maxValue = this.getValue('max');
    },
    computed: {
        beforeStartWidth() {
            const range = this.initialMax - this.initialMin;
            return `calc((100% - var(--slider-thumb-size)) * ${(this.minValue - this.initialMin) / range})`;
        },
        afterEndWidth() {
            const range = this.initialMax - this.initialMin;
            return `calc((100% - var(--slider-thumb-size)) * ${(this.initialMax - this.maxValue) / range})`;
        },
    },
    methods: {
        getValue(minOrMax) {
            let result = minOrMax === 'min' ? this.initialMin : this.initialMax;
            const selectedRangeFilter = this.value.find((item) => item.includes(this.sliderType + '-'));
            if (selectedRangeFilter) {
                const [min, max] = selectedRangeFilter.split('-')[1]?.split('_');
                if (minOrMax === 'min') {
                    result = min || this.initialMin;
                } else {
                    result = max || this.initialMax;
                }
            }
            return parseInt(result);
        },
        updateValue(event) {
            const newValue = event?.target?.value;
            const name = event?.target?.name;
            if (name === 'min') {
                const validMinValue = Math.min(newValue, this.maxValue - this.step);
                this.minValue = validMinValue;
                event.target.value = validMinValue;
            } else {
                const validMaxValue = Math.max(newValue, this.minValue + this.step);
                this.maxValue = validMaxValue;
                event.target.value = validMaxValue;
            }
            this.$emit('input', this.updateRangeFilter(`${this.sliderType}-${this.minValue}_${this.maxValue}`));
        },
        updateRangeFilter(newValue) {
            const prev = [...this.value];
            return [...prev.filter((item) => !item.includes(this.sliderType)), newValue];
        },
    },
};
